import React from 'react';
import { Box } from '@mui/material';
import { uniq } from 'lodash';
import { ConfirmationCannotDeleteProps } from './ConfirmationCannotDelete.props';
import { Message, MessagesContainer, Paragraph } from './ConfirmationCannotDelete.styles';

const ConfirmationCannotDelete = ({ messages = [], itemName = 'element' }: ConfirmationCannotDeleteProps) => {
  const uniqueMessages = uniq(messages);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <Box alignSelf="start">
        <>
          <Paragraph>This {itemName} cannot be deleted because it is being used in:</Paragraph>
          <MessagesContainer>
            {uniqueMessages.map(message => (
              <Message key={message}>{message}</Message>
            ))}
          </MessagesContainer>
          <Paragraph>Please remove this {itemName} there first.</Paragraph>
        </>
      </Box>
    </Box>
  );
};

export default ConfirmationCannotDelete;
